import React, { useEffect, useState } from 'react';
import { Box, Alert, CircularProgress } from '@mui/material';
import RuleGroupRow from './RuleGroupRow';
import { getSegmentationFields, getIndustries, getIndustryGroups } from '../../services/api';

const emptyEnvelope = () => ({
  version: 1,
  root: { kind: 'group', op: 'AND', children: [] },
});

export default function RuleBuilder({ value, onChange }) {
  const [fields, setFields] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [industryGroups, setIndustryGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    Promise.all([getSegmentationFields(), getIndustries(), getIndustryGroups()])
      .then(([fieldsRes, industriesRes, groupsRes]) => {
        if (!mounted) return;
        setFields(fieldsRes.data || []);
        setIndustries(industriesRes.data || []);
        setIndustryGroups(groupsRes.data || []);
      })
      .catch((err) => mounted && setError(err.response?.data?.message || err.message))
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  const envelope = value || emptyEnvelope();

  const updateRoot = (nextRoot) => {
    onChange({ ...envelope, root: nextRoot });
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress size={20} />
      </Box>
    );
  }
  if (error) return <Alert severity="error">{error}</Alert>;
  if (fields.length === 0) return <Alert severity="warning">No queryable fields available.</Alert>;

  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 2 }}>
      <RuleGroupRow
        group={envelope.root}
        onChange={updateRoot}
        fields={fields}
        industries={industries}
        industryGroups={industryGroups}
        depth={0}
        isRoot
      />
    </Box>
  );
}
